import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AuthProvider, useAuth } from '@/features/auth/auth-context';
import { OnayPenceresi } from '@/components/ui/onay-penceresi';
import { LoginPage } from '@/features/auth/login-page';
import { ApiError } from '@/lib/api';
import { router } from '@/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // §19.3 — stale-while-revalidate
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Yetki ve doğrulama hataları tekrar denenmez — sonuç değişmez
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

/** Oturum yoksa uygulama kabuğu hiç kurulmaz; doğrudan giriş ekranı gösterilir. */
function AuthGate() {
  const { user, initializing } = useAuth();

  if (initializing) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg">
        <div className="space-y-3 text-center">
          <img
            src="/logo.svg"
            alt=""
            className="mx-auto size-11 rounded-[var(--radius)]"
            aria-hidden="true"
          />
          <div className="mx-auto size-6 animate-spin rounded-full border-2 border-border-strong border-t-accent" />
          <p className="text-sm text-fg-muted">Oturum kontrol ediliyor…</p>
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AuthGate />
        <OnayPenceresi />
      </AuthProvider>
    </QueryClientProvider>
  );
}
